import _get from 'lodash/get';

/*
    If the API call that was interrupted by reload was getLastQuestion() isLoadingCurrentQuestion will be true and we should not update questionIndex.
  */
const calculateQuestionIndexOnLoad = (questionIndexFromStorage, isForwardNavigation, isLoadingCurrentQuestion) => {
  if (isLoadingCurrentQuestion) {
    return questionIndexFromStorage;
  }
  return isForwardNavigation ? questionIndexFromStorage + 1 : questionIndexFromStorage - 1;
};
  /*
    If the call to rehydrate state from the sessionStorage happens when isLoading is set to true, we know the reload has happened during an API call.
    Here we realign state with the API, UI, and history.state.questionIndex.
    We empty the question object to tell the UI to re-request it.
    We then update the questionIndex to match the history.questionIndex to prevent getNextQuestion/getPreviousQuestion being called on load.
    We're also setting responseType to QUESTION, this is because if a patient is back stepping from an ADVICE_EMERGENCY screen the UI wont call getLastQuestion on an endState
  */
export const evaluateNonPersistableState = persistedState => {
  const questionIndex = _get(persistedState, 'consultationReducer.questionIndex', 0);
  const isForwardNavigation = _get(persistedState, 'consultationReducer.isForwardNavigation', true);
  const isLoadingLastQuestion = _get(persistedState, 'consultationReducer.isLoadingLastQuestion', false);
  const responseType = _get(persistedState, 'consultationReducer.responseType', 'QUESTION');
  return {
    consultationReducer: {
      ...persistedState.consultationReducer,
      question: {},
      questionIndex: calculateQuestionIndexOnLoad(questionIndex, isForwardNavigation, isLoadingLastQuestion),
      responseType: isForwardNavigation ? responseType : 'QUESTION',
    },
  };
};
